import Page from 'components/pages/academy'

export default function Academy() {
  const t = useI18n()
  const title = t('common:breadcrumb.academy')
  const description = t('page:academy.hero.description')
  return (
    <>
      <C.Head>
        { h.seo({ title, description }) }
      </C.Head>
      <Page />
    </>
  )
}
